/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { requisitionConfirmationPageContainerStyles } from "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationPageContainer";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

requisitionConfirmationPageContainerStyles.container = {
    css: css`
        /* stylelint-disable value-no-vendor-prefix */
        display: -ms-grid;
        display: grid;
        grid-column-gap: 60px;
        grid-row-gap: 30px;

        grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
        -ms-grid-columns: minmax(0, 2fr) minmax(0, 1fr);

        ${screen("lte", "lg")} {
            grid-row-gap: 15px;
            grid-column-gap: 20px;
        }
    `,
};

requisitionConfirmationPageContainerStyles.cartLinesContainer = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 2 / 3;
        ${screen("lte", "sm")} {
            grid-column: 1 / 3;
        }
    `,
};

requisitionConfirmationPageContainerStyles.totalContainer = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 2 / 3;
        position: relative;
        & > * {
            position: sticky;
            top: 175px;
        }
        ${screen("lte", "sm")} {
            grid-column: 1 / 3;
            grid-row: 3 / 4;
        }
    `,
};
